import React, { useState, useCallback, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'
import {
  Button,
  Container,
  Dropdown,
  FAQ,
  GridContainer,
  GridColumn,
  Heading,
  IconButton,
  IconLink,
  Legend,
  ListSelection,
  Main,
  NavBar,
  ProgressionIndicator,
  Text,
  UseIcon,
  Loader,
  ValidationFeedback,
  Input,
  Form,
  OptionsRadios, CompanyLogo
} from '@domain/components';
import { carBrandsSchadegarant, proccessType } from '@domain/constants';
import {
  getPrevNextPagePath,
  goToNextPage,
  browserStorage,
  generatePageContent, mapYupValidationSchemaErrors, chooseLogoSize
} from '@domain/helpers';
import { useNavigate, useLocation } from 'react-router-dom'
import { useFaq, useGetBodyshopLists, useScaling, useEnterKey, useSaveIncidentFactory } from '@domain/hooks';
import { styled, useTheme } from '@mui/material/styles';
import { detectContentType } from '@domain/content';
import { isMobile } from 'react-device-detect';
import { validationSchema, validationSchemaNotRequired } from './validation-schema';
import { useQuestionnaire } from '@domain/providers';


const faqs = [
  {
    question: 'Waarom moet ik het merk van mijn auto aangeven?',
    answer: 'Wij hebben het merk van uw auto nodig om een geschikt herstelbedrijf te vinden.',
  },
  {
    question: 'Waarom moet ik de radius invullen?',
    answer: 'We gebruiken de radius om alle geschikte herstelbedrijven voor u in kaart te brengen.',
  },
  {
    question: 'Wat gebeurt er als ik een andere postcode of plaatsnaam invul?',
    answer: 'We zullen op basis van de door u aangeven postcode of plaatsnaam herstelbedrijven tonen die beschikbaar zijn in de door u opgegeven locatie.',
  },
];

const StyledMain = styled(Main, {
  shouldForwardProp: (propName) => !propName.startsWith('$')
})`
  .bodyshop-select {
    &__container {
      justify-content: center;
      .grid__column {
        flex: 0 0 auto;
        &.bodyshop-select__main {
          padding-top: 30px;
        }
      }
    }
    &__title {
      flex: 1;
      h1 {
        margin-bottom: 0;
      }
    }
    &__main {
      padding: 20px 0;
      }
    }
    &__footer {
      flex-direction: row;
      justify-content: flex-end;
      &--button-container {
        width: 100%;
        .button {
          width: 100%;
        }
      }
    }
  }

  .screen-desktop & {
    .bodyshop-select {
      &__container {
        // padding: 0 ${props => props.$scaling.scaleUpTo4K(120)}px ${props => props.$scaling.scaleUpTo4K(82)}px;
        flex-direction: column;
      }
      &__title {
        padding: ${props => props.$scaling.scaleUpTo4K(60)}px 0 ${props => props.$scaling.scaleUpTo4K(30)}px;
      }
      &__main {
        padding: 0;
        flex-direction: column;
      }
      &__footer {
        // padding-bottom: ${props => props.$scaling.scaleUpTo4K(60)}px;
        &--button-container {
          width: auto;
          .button {
            width: ${props => props.$scaling.scaleUpTo4K(240)}px;
          }
        }
      }
    }
    .grid__column--main {
      max-width: none;
    }
  }

  @media screen and (max-width: 1028px) {
    .screen-desktop & {
      .bodyshop-select {
        &__container {
          .grid__column {
            flex: 0 0 auto;
            padding-top: 0;
          }
        }
        &__title {
          text-align: center;
          h1 {
            max-width: none;
          }
        }
        &__main {
        }
        &__footer {
          max-width: 500px;
          margin: auto auto 0;
          padding-bottom: 0;
          &--button-container {
            margin: auto;
            @media screen and (min-width: 581px) {
            margin: 0;
            width:100%;
            .button {
              width:100%
            }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 580px) {
    .bodyshop-select {
      &__container {
        .grid__column {
          &.bodyshop-select__main {
            flex: 1 0 auto;
          }
        }
      }
      &__title {
        h1 {
        }
      }
      &__main {
        .list__container {
        }
      }
      &__footer {
      }
    }

    .screen-desktop & {
      .bodyshop-select {
        &__container {
          .grid__column {
          }
        }
        &__title {
          text-align: left;
          h1 {
            margin-left: 0;
            flex-grow: 0;
          }
        }
        &__main {
          .list__container {
          }
        }
        &__footer {
          &--button-container {
            width: 100%;
            .button {
              width: 100%;
            }
          }
        }
      }
    }
  }
`;


const ListContainer = styled(Container, {
  shouldForwardProp: (propName) => !propName.startsWith('$')
})`
  display: flex;
  flex: 1 1 auto;
  &.list-bodyshop__container {
    min-height: 260px;
  }
  &.list-control__container {
    flex-direction: column;
    padding-bottom: 40px;
    > div {
      width: 100%;
    }
    .MuiFormControl-root {
      flex: 1 1 0px;
      margin: 0 0 20px;
      .MuiInputLabel {
        &-root {
          font-size: 24px;
        }
        &-shrink {
          font-size: 14px;
        }
      }
    }
    .form-postcode-city {
      width: 35%;
      align-self: flex-end;
    }
    .list-control__button-container {
      display:flex;
      flex: 1 1 0px;
      button {
        height: 42px;
      }
    }
  }
  .loader {
    padding: ${props => props.$scaling.scaleUpTo4K(60)}px;
    padding-top: ${props => props.$scaling.scaleUpTo4K(40)}px;
  }
  .screen-desktop & {
      margin: 0 -${props => props.$scaling.scaleUpTo4K(20)}px;
      ul {
        margin: 0 ${props => props.$scaling.scaleUpTo4K(20)}px ${props => props.$scaling.scaleUpTo4K(40)}px;
      }
      .loader {
        padding-top: ${props => props.$scaling.scaleUpTo4K(80)}px;
      }
    &.list-control__container {
      flex-direction: row;
      @media screen and (max-width: 1028px) and (min-width: 581px) {
          &.dropdown {
            width: 100%;
            max-width:100%;
            flex-direction: column;     
            justify-content: center;
            .MuiFormControl-root {
              margin-bottom:20px;
            }
          }
    }
      max-width: 50%;
      &.button-opt {
        max-width: 73%;
        @media screen and (max-width: 1028px) and (min-width: 581px) {
          width: 100%;
            max-width:100%;
            flex-direction: column;     
            justify-content: center;
            .MuiFormControl-root {
              margin-bottom:20px;
            }
        }
      }
      .MuiFormControl-root {
        flex: 1 1 0px;
        margin: 0 ${props => props.$scaling.scaleUpTo4K(20)}px;
      }
      .list-control__button-container {
        flex: 1 1 0px;
        button {
          width: auto;
          margin: auto 0 auto ${props => props.$scaling.scaleUpTo4K(10)}px;
           @media screen and (max-width: 1028px) and (min-width: 581px) {
            width: 100%;
           }
        }
      }
    }
  }
  @media screen and (max-width: 1028px) {
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0px;
    &.list-control__container {
      .MuiFormControl-root {
        margin: ${props => props.$scaling.scaleUpTo4K(20)}px 0 ${props => props.$scaling.scaleUpTo4K(20)}px 0;
      }
      max-width: 100%;
      padding-bottom: 60px;
      flex-direction: column;
      justify-content: flex-start;
      .form-postcode-city {
        width: 100%;
        align-self: flex-start;
        padding-bottom:20px;
      }
    }
    .main__damage--bodyshop-select & {
      ul.MuiList-root {
        min-width: 260px;
        max-width: 100%;
        // + ul.MuiList-root {
        //   + ul.MuiList-root {
        //     //third block should be full width when wrapped
        //     width: 100%;
        //     max-width: 100%;
        //   }
        }
      }
    }
  }
  @media screen and (max-width: 580px) {
    flex-direction: column;
    flex-wrap: nowrap;
    ul {
      min-height: 220px;
    }
    .main__damage--bodyshop-select & {
      ul.MuiList-root {
        width: 100%;
        max-width: 100%;
      }
    }
    &.list-bodyshop__container {
      min-height: 220px;
    }
    &.list-control__container {
      padding-bottom: 20px;
    }

    .screen-desktop & {
      margin: 0;
      ul {
        margin: 0 0 30px;
        min-height: 260px;
      }
      &.list-control__container {
        flex-direction: column;
        padding-bottom: 20px;
        max-width: 100%;
        &.button-opt {
          max-width: 73%;
        }
      .list-control__container {
        flex-direction: column;
        .MuiFormControl-root {
          max-width: 100%;
          margin: ${props => props.$scaling.scaleUpTo4K(20)}px 0 ${props => props.$scaling.scaleUpTo4K(20)}px 0;
          .form-postcode-city {
            width: 100%;
            align-self: flex-start;
          }
        }
        .list-control__button-container {
          .button {
            margin-left: 0;
            width: 100%;
          }
        }
      }
      &.list-bodyshop__container {
        min-height: 260px;
      }
    }
  }
`;

const debiteurnummerName = 'debiteurNummer';

const radiusValueList = {
  '5': '5 km',
  '10': '10 km',
  '15': '15 km',
  '20': '20 km',
  '25': '25 km',
  '30': '30 km',
}

function BodyshopSelect() {
  const navigate = useNavigate()
  const location = useLocation()
  const { questionnaire, updateQuestionnaire } = useQuestionnaire();
  const bsLists = useSelector(state => state.bodyshopLists);
  const incident = useSelector(state => state.incident);
  const insurer = useSelector(state => state.insurer);
  const token = useSelector(state => state.token);
  const files = useSelector(state => state.files)

  const themeContext = useTheme();

  const isSG = insurer && insurer.objectType === proccessType.Schadegarant

  const scaling = useScaling();
  const [
    faqVisible,
    handleOnHelpClick,
    clickOutSideFaq,
    faqListProps,
    faqSeen,
  ] = useFaq();

  const currentValue = incident[debiteurnummerName] || incident.carRefinisherUUID
  const [debiteurNummer, setDebiteurNummer] = useState(currentValue);
  const [selectedList, setSelectedList] = useState();
  const localRadius = browserStorage.getRadius() || null
  const localCarMake = browserStorage.getCarMake() || null
  const [radius, setRadius] = useState(localRadius || '10');
  const [carMake, setCarMake] = useState(localCarMake || incident.vehicleMake || '');
  const [listsLoading, setListsLoading] = useState(false);
  const [listsLoadingError, setListsLoadingError] = useState(false);
  const [listsLoadingEmpty, setListsLoadingEmpty] = useState(false);

  const damageType = incident.damageType || '';

  const nextPageEnabled = !!debiteurNummer && debiteurNummer !== '';


  const currentPath = location.pathname;
  const page = questionnaire.find(page => page.path === currentPath)
  const saveBehavior = page ? page.saveBehavior : undefined

  const saveIncident = useSaveIncidentFactory(incident, saveBehavior);

  useEffect(() => {
    if (!!questionnaire && questionnaire.length) {
      const page = questionnaire.find(page => page.path === currentPath)
      const progress = page ? page.name : null
      if (progress) {
        browserStorage.setProgress(progress);
      }

    }
  }, [currentPath, questionnaire])

  const inBodyshopChange = browserStorage.getInBodyshopChange();

  const getBodyshopLists = useGetBodyshopLists();


  useEffect(() => {
    if (!bsLists) {
      return;
    }
    // const bsListsNames = Object.keys(bsLists);
    // console.log(!!bsLists[bsListsNames[0]]
    //   && bsLists[bsListsNames[0]].length === 0);
    // console.log(((bsLists.length >= 2 && (!!bsLists[bsListsNames[1]]
    //   && bsLists[bsListsNames[1]].length === 0)) || bsLists.length < 2));
    // if (
    //   !!bsLists[bsListsNames[0]]
    //   && bsLists[bsListsNames[0]].length === 0

    //   && ((bsLists.length >= 2 && (!!bsLists[bsListsNames[1]]
    //   && bsLists[bsListsNames[1]].length === 0)) || bsLists.length < 2)
    if (
      Object.keys(bsLists).length === 0
    ) {
      setListsLoadingEmpty(true);
    } else {
      setListsLoadingEmpty(false);
    }
    setListsLoading(false);
  }, [bsLists]);

  const isPageBeforeSuccess = questionnaire[questionnaire.length - 2].path === currentPath

  async function handleClick(event) {
    event.preventDefault();
    if (isSG) {
      const updatedDebiteurNummer = debiteurNummer ? debiteurNummer : currentValue;
      const savedIncident = await saveIncident({ ...incident, [debiteurnummerName]: updatedDebiteurNummer, token: token }, isPageBeforeSuccess)
      if (savedIncident) {
        goToNextPage(navigate, questionnaire, savedIncident, currentPath, files)
      }
    } else {
      const carRefinisherUUID = debiteurNummer ? debiteurNummer : currentValue;
      const savedIncident = await saveIncident({ ...incident, carRefinisherUUID: carRefinisherUUID, token: token }, isPageBeforeSuccess)
      if (savedIncident) {
        goToNextPage(navigate, questionnaire, savedIncident, currentPath, files)
      }
    }
  }

  const handleOnChangeRadius = (event) => {
    setRadius(event.target.value);
    browserStorage.setRadius(event.target.value)
  }
  const handleOnChangeCarMake = (event) => {
    setCarMake(event.target.value);
    browserStorage.setCarMake(event.target.value)
  }


  const renderBodyshopLists = useCallback(() => {
    if (!bsLists || Object.keys(bsLists).length === 0) {
      return;
    }
    if (listsLoading) {
      return <Loader />;
    }

    const bsListsNames = Object.keys(bsLists)
    const handleClickItem = ({ title, listTitle }) => {
      if (isSG) {
        const selectedBodyshop = bsLists[listTitle].find(item => item.naam === title);
        setSelectedList(listTitle);
        setDebiteurNummer(selectedBodyshop.debiteurnummer);
      } else {
        const selectedBodyshop = bsLists[listTitle].find(item => item.companyName === title);
        setSelectedList(listTitle);
        setDebiteurNummer(selectedBodyshop.uuid);
      }
    }

    const generateBodyshopList = () => {
      const formattedList = {};
      if (isSG) {
        Object.keys(bsLists).map((key, i) => {
          formattedList[key] = bsLists[key];
          formattedList[key].map((item, i) => {
            item.title = bsLists[key][i].naam
            item.subtitle = bsLists[key][i].adres.plaats
            item.uuid = bsLists[key][i].debiteurnummer
            return item;
          })
          return key;
        });
      } else {
        Object.keys(bsLists).map((key, i) => {
          formattedList[key] = bsLists[key];
          formattedList[key].map((item, i) => {
            item.title = bsLists[key][i].companyName;
            item.subtitle = bsLists[key][i].city;
            return item;
          })
          return key;
        });
      }

      return formattedList;
    };
    const bodyshopList = generateBodyshopList();
    return (
      <>
        <ListSelection
          large={damageType !== 'glass'}
          listItems={bodyshopList[bsListsNames[0]]}
          listTitle={bsListsNames[0]}
          onClickItem={handleClickItem}
          selectedListName={selectedList}
          {...(currentValue ? { preselectedItemUUID: currentValue } : {})}
        />
        {bsListsNames.length >= 2 && <ListSelection
          large={damageType !== 'glass'}
          listItems={bodyshopList[bsListsNames[1]]}
          listTitle={bsListsNames[1]}
          onClickItem={handleClickItem}
          selectedListName={selectedList}
          {...(currentValue ? { preselectedItemUUID: currentValue } : {})}
        />}
        {damageType !== 'glass' && bsListsNames.length >= 3 &&
          <ListSelection
            large={damageType !== 'glass'}
            listItems={bodyshopList[bsListsNames[2]]}
            listTitle={bsListsNames[2]}
            onClickItem={handleClickItem}
            selectedListName={selectedList}
            {...(currentValue ? { preselectedItemUUID: currentValue } : {})}
          />
        }
      </>
    );
  }, [bsLists, damageType, isSG, listsLoading, currentValue, selectedList]);


  const form = {
    id: 'zipCodeCity'
  };
  const field = {
    name: 'zipCodeOrCity',
    label: 'Postcode of plaatsnaam',
    mandatory: false,
  }

  const radioOptions = [{
    name: 'customerZipCode',
    label: 'Gebruik mijn postcode',
  }, {
    name: 'choosePostcodeOrCity',
    label: 'Andere postcode of plaatsnaam',
  }]

  const [buttonClicked, setButtonClicked] = useState(false);
  const [values, setValues] = useState({ [field.name]: incident.customerZipCode });
  const [errors, setErrors] = useState({});

  async function handleChange(event) {
    const { name, value } = event.target;
    const valueToSet = value;
    setValues(vals => ({ ...vals, [name]: valueToSet }));
  }

  const formInput = ({ name, label, type, displayLabel = true }) => ({
    type: 'text',
    name,
    placeholder: '1234AB / amsterdam',
    id: name,
    valid: !errors[name] || !buttonClicked,
    onChange: handleChange,
    label,
    regexPass: !errors[name],
    disabled: radioValue === 'customerZipCode',
    value: values[name],
    displayLabel,
    displayEndAdornment: false,
    customBaseSize: 23
  });


  function hasNumbers(t) {
    var regex = /\d/g;
    return regex.test(t);
  }

  const validationSchemaToBeUsed = useCallback(() => {
    if (hasNumbers(values.zipCodeOrCity)) {
      return validationSchema
    }
    return validationSchemaNotRequired
  }, [values.zipCodeOrCity])

  useEffect(() => {
    async function testInputs() {
      try {
        await validationSchemaToBeUsed().validate(values, { abortEarly: false });
        setErrors({});
      } catch (errorResult) {
        setErrors(mapYupValidationSchemaErrors(errorResult.inner));
      }
    }
    testInputs();
  }, [values, validationSchemaToBeUsed]);

  async function handleOnClickSearch(event) {
    event.preventDefault();
    setButtonClicked(true)
    try {
      await validationSchemaToBeUsed().validate(values, { abortEarly: false });
      setListsLoading(true);
      if (hasNumbers(values.zipCodeOrCity)) {
        const searchZipCode = values.zipCodeOrCity
          .toUpperCase()
          .replace(/ /g, '');

        const checkZipCode = searchZipCode === incident.customerZipCode ? null : searchZipCode
        const listsLoaded = await getBodyshopLists(carMake, radius, checkZipCode, null);
        if (!listsLoaded) {
          setListsLoadingError(true);
        } else {
          setListsLoadingError(false);
        }
      } else {
        setListsLoading(true);
        const listsLoaded = await getBodyshopLists(carMake, radius, null, values.zipCodeOrCity);
        if (!listsLoaded) {
          setListsLoadingError(true);
        } else {
          setListsLoadingError(false);
        }
      }
    } catch (errorResult) {
      setErrors(mapYupValidationSchemaErrors(errorResult.inner));
    }
  }

  const [radioValue, setValue] = React.useState('customerZipCode');

  const disableEnterKey = (!carMake && isSG) || (buttonClicked && errors[field.name]) || (radioValue !== 'customerZipCode' && !values.zipCodeOrCity)
  const onEnterKey = (event) => {
    event.preventDefault();
    if (!disableEnterKey) {
      handleOnClickSearch(event)
    }
  }

  useEnterKey(onEnterKey)

  const handleChageRadioValue = (event) => {
    setValue(event.target.value);
    setValues({ [field.name]: incident.customerZipCode })
  };


  const searchButton = {
    disabled: Boolean((!carMake && isSG) || (buttonClicked && errors[field.name]) || (radioValue !== 'customerZipCode' && !values.zipCodeOrCity)),
    theme: (!carMake && isSG) || (buttonClicked && errors[field.name]) || (radioValue !== 'customerZipCode' && !values.zipCodeOrCity) ? 'disabled' : 'primary',
    shadow: false,
    onClick: handleOnClickSearch,
    className: "search-button"
  }


  useEffect(() => {
    const reloadPageConfigForInbsChange = async () => {
      await updateQuestionnaire({ configuration: [{ "index": 1, "name": "bodyshop_select" }, { "index": 2, "name": "bodyshop_confirm" }, { "index": 3, "name": "track_trace" }] });
    }
    if (inBodyshopChange && questionnaire && questionnaire.length !== 3) {
      reloadPageConfigForInbsChange()
    }
  }, [inBodyshopChange, questionnaire, updateQuestionnaire])

  if (!insurer || !incident || !questionnaire || (questionnaire && !questionnaire.length)) {
    return <Loader />
  }

  const pagePath = inBodyshopChange ? { prevPage: undefined, nextPage: undefined } : getPrevNextPagePath(
    questionnaire,
    incident,
    currentPath,
    files,
  );
  const nextPage = pagePath.nextPage !== currentPath
    ? pagePath.nextPage
    : undefined;

  const main = {
    faqVisible: faqVisible,
    dimmed: faqVisible,
    className: 'main__damage main__damage--bodyshop-select',
    callBack: clickOutSideFaq,
    $scaling: scaling,
  }

  const iconLink = (triggerKey) => ({
    type: 'arrow-left',
    theme: 'secondary',
    to: pagePath.prevPage,
    replace: true,
    triggerKey
  });

  const iconLinkForward = (triggerKey) => ({
    type: 'arrow-right',
    theme: 'secondary',
    to: nextPage,
    replace: true,
    triggerKey
  });

  const iconButton = {
    type: faqVisible ? 'arrow-right' : 'questionmark',
    className: faqSeen ? '' : 'unclicked-faq-button',
    theme: 'secondary',
    onClick: handleOnHelpClick,
    faq: true,
  };

  const button = {
    className: 'button--icon',
    justify: 'space-between',
    onClick: handleClick,
    shadow: true,
    theme: nextPageEnabled ? 'primary' : 'disabled',
  };

  const contentType = detectContentType(insurer)
  const pageName = questionnaire.find(page => page.path === currentPath).name
  const content = generatePageContent(contentType, insurer, incident, false, false, pageName)

  const legend = content["over-title-text"]
  const heading = content["title"]
  const customHelpLink = content["custom-help-link"]
  const helpLinkText = content["help-link-text"]
  const useCustomLogo = content["use-custom-logo"]

  const middleLogo = {
    src: insurer.logoURL || '',
    alt: insurer.brandName || 'uw verzekeraar',
    width: '100%',
    height: chooseLogoSize(themeContext.logoSize),
  }

  const chooseMiddleComponent = useCustomLogo
    ? <CompanyLogo {...middleLogo} />
    : <ProgressionIndicator steps={3} current={2} />

  return (
    <React.Fragment>
      <FAQ
        faqListProps={faqListProps}
        faqs={faqs}
        faqLink={insurer.helpcenterLink}
        customHelpLink={customHelpLink}
        helpLinkText={helpLinkText}
        faqVisible={faqVisible}
      />
      <StyledMain {...main}>
        <NavBar>
          <Container className="icon-link-container">
            {pagePath.prevPage && <IconLink {...iconLink([37])} />}
            {nextPage && <IconLink {...iconLinkForward([39])} />}
          </Container>
          {chooseMiddleComponent}
          <Container className="faq-button-container">
            <IconButton {...iconButton} />
          </Container>
        </NavBar>
        <GridContainer main={true} className="bodyshop-select__container" direction='column'>
          <GridColumn className="bodyshop-select__title">
            <Legend>{legend}</Legend>
            <Heading level="1">{heading}</Heading>
          </GridColumn>
          <GridColumn className="grid__column--main bodyshop-select__main">
            <ListContainer
              className="list__container list-control__container button-opt"
              $scaling={scaling}
            >
              <OptionsRadios options={radioOptions} value={radioValue} handleChange={handleChageRadioValue} />
              <Form className={'form-postcode-city'} {...form} >
                <Container className="form-input">
                  <Input
                    {...formInput(field)}
                    autoFocus={!isMobile}
                  />
                  <Container className="validation__container">
                    {buttonClicked && errors[field.name] && (
                      <ValidationFeedback type="error">{errors[field.name]}</ValidationFeedback>
                    )}
                  </Container>
                </Container>
              </Form>
              <Container className="list-control__button-container">
                <Button {...searchButton}>
                  {(!carMake && isSG) ? 'Kies een merk a.u.b.' : (buttonClicked && errors[field.name]) || (radioValue !== 'customerZipCode' && !values.zipCodeOrCity) ? 'Vul de plaats in a.u.b.' : 'Resultaten tonen'}</Button>
              </Container>
            </ListContainer>
            <ListContainer
              className="list__container list-control__container dropdown"
              $scaling={scaling}
            >
              {isSG && <Dropdown
                id="dropdownMerk"
                label="Merk"
                onChange={handleOnChangeCarMake}
                value={carMake}
                disabled={Boolean(incident.vehicleMake)}
                valueList={carBrandsSchadegarant}
              />}
              <Dropdown
                id="dropdownRadius"
                label="Radius"
                onChange={handleOnChangeRadius}
                value={radius}
                valueList={radiusValueList}
              />
            </ListContainer>
            {/* <ListContainer
              className="list__container list-control__container"
              $scaling={scaling}
            >
            
            </ListContainer> */}
            <Container>
              {
                listsLoadingError &&
                <ValidationFeedback>Op het moment kunnen wij door een technische storing geen lijst met herstelbedrijven tonen. Probeer het over een paar minuten nog een keer.</ValidationFeedback>
              }
              {
                listsLoadingEmpty &&
                <ValidationFeedback>Er zijn geen resultaten voor de combinatie van merk, postcode en straal.</ValidationFeedback>
              }
            </Container>
            <ListContainer
              className="list__container list-bodyshop__container"
              $scaling={scaling}
            >

              {renderBodyshopLists()}
            </ListContainer>
          </GridColumn>
          <GridColumn
            className=" grid__column--footer bodyshop-select__footer"
          >
            <Container className="bodyshop-select__footer--button-container">
              {' '}
              <Button {...button}>
                Volgende
                <UseIcon name="arrow-right" className="button__icon" />
              </Button>
              <Text className="of--enter">
                of <b>ENTER</b>
              </Text>
            </Container>
          </GridColumn>
        </GridContainer>
      </StyledMain>
    </React.Fragment>
  )
}

export default BodyshopSelect;
